export default __webpack_public_path__ + "static/media/five.6d483758.jpg";